module.exports = __webpack_public_path__ + "static/media/Numel_gaussian2.f4f6c93b.png";